import { useEffect } from "react"
import { Toaster, toast } from "sonner"

type AppToasterProps = {
  theme: "light" | "dark"
}

function dismissToastFromEventTarget(target: EventTarget | null) {
  const el = target instanceof Element ? target : null
  if (!el) return

  const toastEl = el.closest("[data-sonner-toast]")
  if (!toastEl) return
  if (el.closest("button, [data-button], [data-close-button], a")) return

  const active = toast.getToasts()
  const indexAttr = toastEl.getAttribute("data-index")
  const index = indexAttr != null ? Number(indexAttr) : NaN
  if (Number.isFinite(index) && active.length > 0) {
    // Sonner: data-index 0 is the front (newest) toast.
    const matched = active[active.length - 1 - index] ?? active[active.length - 1]
    if (matched) {
      toast.dismiss(matched.id)
      return
    }
  }

  const front = active[active.length - 1]
  if (front) {
    toast.dismiss(front.id)
    return
  }

  toast.dismiss()
}

export function AppToaster({ theme }: AppToasterProps) {
  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      dismissToastFromEventTarget(e.target)
    }
    document.addEventListener("click", onClick, true)
    return () => document.removeEventListener("click", onClick, true)
  }, [])

  return (
    <Toaster
      richColors
      position="top-center"
      theme={theme}
      className="app-toaster"
      toastOptions={{
        classNames: {
          toast: "app-toast",
        },
      }}
    />
  )
}
